import { PreloadImages } from "./components/preloadImage"
import { FallbackImages } from "./components/FallbackImages"
import { AxiosApi } from "./components/AxiosApi"
import { Suffix } from "./components/Suffix"
import Helper from "./components/Helper"
import { NameCols } from "./components/conf/NameCols"

const img_container = "/App_Firma/img/product/conf/small_icon";
const img_container_icon = "/App_Firma/data";
const container_documents = "/App_Firma/Data/Files/nomenklatura";

let data_conf = new Array(),
    typ_atributu = "",
    ornament_modul,
    url_nahled = "";

let file_data, template = "", templateMain="", smako_tech_info, template_tech="";

let column = [""];
let column_nbdil = ["grp_folie", "kod_folie", "smer_let", "patina", "folie_spec", "", "grp_zada", "kod_zada", "zada_spec", "grp_prov", "kod_prov", "sila", "grp_skla", "kod_skla", "sklo_spec", "smer_skla", "ornament_skla", "hrana_h", "hrana_p", "hrana_d", "hrana_l", "grp_pantu", "kod_pantu","", "pant_povrch","pant_spec", "pant_umi", "vrtani", "kovani", "vyklop", "poznamka"];
const loader = '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
const error = '<div class="error error_text">Tento údaj je povinný</div>';
let column_modul = ["grp_folie", "kod_folie",  "folie_spec", "sila", "kod_prov", "smer_let", "grp_zada", "kod_zada", "zada_spec", ];

const column_hp = ["grp_folie", "kod_folie", "folie_spec", "smer_let","", "kod_pantu", ""];
const column_hp_delete = ["height", "width"];

const column_lista = ["grp_folie", "kod_folie",  "folie_spec", "kod_frezovani", "", "" ];
const column_lista_delete = ["height", "width"];

const column_lipro = ["grp_folie", "kod_folie",  "folie_spec", "kod_frezovani", "", "" ];
const column_lipro_delete = ["width"];

const column_drvd = ["grp_skla", "kod_skla",  "sklo_spec"];

const column_uchmm = ["pant_povrch", "pant_spec"];
const column_uchmm_delete = ["width"];

const column_ual = [];
const column_ual_delete = ["height", "width"];

const column_sklo = [ "grp_skla", "kod_skla", "sklo_spec", "smer_skla" ];

var callNow = "";

// Orientace ornamentu Svislá 10/Vodorovná 20
data_conf["smer_skla"] = [{name: "Svislá" , hodnota: 10, pic: "ic-ver.png"}, {name: "Vodorovná" , hodnota: 20, pic: "ic-hor.png"}];
//Umístění ornamentu Vnitřní strana 10/Vnější strana 20
data_conf["ornament_skla"] = [{name: "Vnitřní" , hodnota: 10}, {name: "Vnější" , hodnota: 20}];
// Vnitřní frézování Ne 0/Ano 1
data_conf["vnitrni_frez"] = [{name: "Ano" , hodnota: 1}, {name: "Ne" , hodnota: 0}];
// Orientace let Svislá 10/Vodorovná 20
data_conf["smer_let"] = [{name: "Svislá" , hodnota: 10, pic: "ic-ver.png"}, {name: "Vodorovná" , hodnota: 20, pic: "ic-hor.png"}];
// Návaznost let   Ne 0/Ano 1
data_conf["navaznost_let"] = [{name: "Ne" , hodnota: 0}, {name: "Ano" , hodnota: 1}];
//Expres  Ne 0/Ano 1
data_conf["expres"] = [{name: "Ano" , hodnota: 1}, {name: "Ne" , hodnota: 0}];
//Dodatečná povrchová úprava    Bez povrchové úpravy 0/Patina 20/Vysoký lesk 90 (tady se mozna budou pridavat další)
data_conf["patina"] = [{popis: "Bez povrchové úpravy" , kod: 0}, {popis: "Patina" , kod: 20}, {popis: "Vysoký lesk" , kod: 90}];
data_conf["montazni_sada"] = [{popis: "Ne" , kod: 0}, {popis: "Ano" , kod: 20}, {popis: "ano včetně adaptéru pro žebrové radiátory" , kod: 90}];
data_conf["otoceni"] = [{popis: "0" , kod: 0}, {popis: "90" , kod: 90}, {popis: "180" , kod: 180}, {popis: "270" , kod: 270}];
data_conf["patina_zada"] = [{popis: "Bez povrchové úpravy" , kod: 0}, {popis: "Patina" , kod: 20}, {popis: "Vysoký lesk" , kod: 90}];

const col_md_3 = ["grp_skla", "kod_skla","sklo_spec" , "hrana_h", "hrana_d", "hrana_l", "hrana_p", "m1", "m1_o", "m2", "m2_o", "m3", "m3_o", "m4", "m4_o", "m5", "m5_o", "m6", "m6_o", "m7", "m7_o", "m8", "m8_o", "m9", "m9_o" ];
const col_md_2 = [ "smer_skla", "ornament_skla"];
const checkboxColumn = [ "smer_let", "navaznost_let", "vnitrni_frez", "smer_skla", "ornament_skla"];
const filter = [ "kod_sklo", "grp_sklo", "smer_skla", "ornament_skla" ];
const with_code = [ "kod_folie", "grp_folie", "kod_prov", "grp_skla", "user_vrtani", "kod_skla", "hrana_h", "hrana_d", "hrana_l", "hrana_p", "kod_zada" ];
const prov_sklo = ["kod_skla", "sklo_spec", "grp_skla", "smer_skla", "ornament_skla" ];
let column_set;

window.validator = new Array();
window.labelName = new Array();
window.helps = new Array();
let user_konf_id = "0";

function formatState(state) {

    if (!state.id) {
        return state.text;
    }

    let kod = "";
    if(state.element){
        if(state.element.getAttribute("kod_append")){
            kod = "<span class='kod_append'>" + state.element.getAttribute("kod_append") + "</span>";
        }
        if(state.element.getAttribute("pic")) {

            const url = img_container_icon + '/' + state.element.getAttribute("pic");

            let $state = $(
                '<span><img loading="lazy" ' +
                '" src= "'+ url +
                '" class="img-swatch" /> ' + kod + state.text + '</span>'
            );
            return $state;
        } else if(state.element.getAttribute("html")) {

            let $state = $(
                '<span><span class="img-swatch ral" style="background-color:' + state.element.getAttribute("html") + '"></span> ' + kod  + state.text + '</span>'
            );
            return $state;
        } else {
            let $state = $(
                '<span>' + kod  + state.text + '</span>'
            );
            return $state;
        }
    }

};

function matchCustom(params, data) {
    // If there are no search terms, return all of the data
    if ($.trim(params.term) === '') {
        return data;
    }

    // Do not display the item if there is no 'text' property
    if (typeof data.text === 'undefined') {
        return null;
    }

    // `params.term` should be the term that is used for searching
    // `data.text` is the text that is displayed for the data object
    if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1 || data.id.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
        let modifiedData = $.extend({}, data, true);
        modifiedData.text += ' (matched)';

        // You can return modified objects from here
        // This includes matching the `children` how you want in nested data sets
        return modifiedData;
    }

    // Return `null` if the term should not be displayed
    return null;
}

var formatSelectImage = function (label) {

    $("#" + label).select2({
        placeholder: 'Vyberte možnost',
        minimumResultsForSearch: 8,
        width: 'resolve',
        templateResult: formatState,
        templateSelection: formatState,
        theme: "foundation",
        language: "cs",
        matcher: matchCustom
    });

};

var configurator = {
    init: async function () {

        next_variant.loaderInit();

        let data_send_folie = "?n=1&command=GET_PRODUCT_CONF_FOLIE_SPEC&cislo_nomenklatury=" + id_nomen;
        let getFolieSpec = function(data) {
            data_conf["folie_spec"] = data.smako_conf_folie_spec.folie_spec;
        }

        let dataFolie = await AxiosApi(data_send_folie);
        getFolieSpec(dataFolie.root);


        let data_send_folie_zad = "?n=1&command=GET_PRODUCT_CONF_ZADA_SPEC&cislo_nomenklatury=" + id_nomen;
        let getZadaSpec = function(data) {
            data_conf["zada_spec"] = data.smako_conf_folie_spec.folie_spec;
        }

        let dataFolieZad = await AxiosApi(data_send_folie_zad);
        getZadaSpec(dataFolieZad.root);

        let data_send_sklo = "?n=1&command=GET_PRODUCT_CONF_SKLO_SPEC&cislo_nomenklatury=" + id_nomen;
        let getSkloSpec = function(data) {
            data_conf["sklo_spec"] = data.smako_conf_sklo_spec.sklo_spec;
        }

        let dataSklo = await AxiosApi(data_send_sklo);
        getSkloSpec(dataSklo.root);


        configurator.getConf();


        $(".has-tip-top").qtip({ // Grab all elements with a title attribute
            content: {
                text: $(this).attr("title") // Won't work, because "this" is the window element!
            },
            show: {
                event: 'mouseover',
                solo: true
            },
            hide: {
                event: 'click unfocus'
            },
            overwrite: false, // Make sure the tooltip won't be overridden once created
            position: {
                my: "bottom center",
                at: "top center",
            },
            style: {
                classes: 'qtip-bootstrap',
                tip: {
                    width: 16,
                    height: 8
                }
            }
        });

    },
    initInputChange: function() {

        $("#konfigurator input").change(function(){

            if($(this).attr("type") == "radio") {

                var value = $( 'input[name=' + $(this).attr("name") +']:checked' ).val();
                configurator.setConfig( $(this).attr("name"), value);

            } else {

                configurator.setConfig( $(this).attr("name") , $(this).val());
            }

            configurator.validate();

        });
    },
    switchClass: function( className, hide , show ){
        $(className).removeClass(hide);
        $(className).addClass(show);
    },
    initSelectChange: function() {
        // select Filter
        let previous;

        $("select").on('focus', function () {
            previous = $(this).val();
        }).change( function () {

            var val = $(this).val();
            var kod = $(this).attr("id");
            var filter_id = kod.replace("grp", "kod");

            if( previous !== val && val ){
                configurator.setConfig( $(this).attr("name"), val);
            }

            if( kod === "kod_prov") {
                if( $(this).find("option:checked").attr("prov_sklo") === 0) {
                    $(".prov_sklo").hide();
                } else {
                    $(".prov_sklo").show();
                }
            }

            if($(this).find("option:checked").attr("folie_spec")) {
                if( $(this).find("option:checked").attr("folie_spec") == 0) {
                    configurator.switchClass(".folie_spec", "vsShow", "vsHide" );
                } else {
                    configurator.switchClass(".folie_spec", "vsHide", "vsShow" );
                }
            }

            if($(this).find("option:checked").attr("sklo_spec")) {
                if( $(this).find("option:checked").attr("sklo_spec") == 0) {
                    configurator.switchClass(".sklo_spec", "vsShow", "vsHide" );
                } else {
                    configurator.switchClass(".sklo_spec", "vsHide", "vsShow" );
                }
            }

            if($(this).find("option:checked").attr("smer_let")) {

                if( $(this).find("option:checked").attr("smer_let") == 0) {
                    configurator.switchClass(".smer_let", "vsShow", "vsHide" );
                    $(".user_vyska, .user_sirka").addClass("switch_size");
                } else {
                    configurator.switchClass(".smer_let", "vsHide", "vsShow" );
                    $(".user_vyska, .user_sirka").removeClass("switch_size");
                }
            }

            if($(this).find("option:checked").attr("data-definice") === "51") {
                $(".pant_povrch , .pant_spec, .pant_umi").hide();
            } else if($(this).find("option:checked").attr("data-definice") === "52") {
                $(".pant_povrch , .pant_spec, .pant_umi").show();
            }

            if(kod.indexOf("grp") === 0) {

                $("#"+ filter_id).select2("destroy");
                $("#"+ filter_id).val(" ");

                $("#"+filter_id + " option").each( function () {

                    $(this).removeAttr("disabled");
                    $(this).removeAttr("aria-disabled");

                    if( val.trim() && val !== $(this).attr("data-filter") && $(this).attr("data-filter") ) {
                        $(this).attr("disabled", "disabled");
                        $(this).attr("aria-disabled", "true");
                    }
                });

                formatSelectImage(filter_id);
            }

            if(kod === "kod_folie") {
                var folie_spec = $(this).find("option:checked").attr("folie_spec");

                if( folie_spec === 0) {
                    $(".folie_spec").addClass("vsHide");
                } else {
                    $(".folie_spec").addClass("vsShow");
                }


                $("#folie_spec").select2("destroy").val(" ");

                $("#folie_spec option").each( function () {

                    $(this).removeAttr("disabled");
                    $(this).removeAttr("aria-disabled");

                    if( folie_spec !== $(this).attr("folie_spec") ) {
                        $(this).attr("disabled", "disabled");
                        $(this).attr("aria-disabled", "true");
                    }
                });

                formatSelectImage("folie_spec");

            }

            if(kod === "kod_zada") {

                var zada_spec = $(this).find("option:checked").attr("zada_spec");

                if( zada_spec === 0) {
                    configurator.switchClass(".zada_spec", "vsShow", "vsHide" );
                } else {
                    configurator.switchClass(".zada_spec", "vsHide", "vsShow" );
                }


                $("#zada_spec").select2("destroy").val(" ");

                $("#zada_spec option").each( function () {

                    $(this).removeAttr("disabled");
                    $(this).removeAttr("aria-disabled");

                    if( zada_spec !== $(this).attr("zada_spec") ) {
                        $(this).attr("disabled", "disabled");
                        $(this).attr("aria-disabled", "true");
                    }
                });

                formatSelectImage("zada_spec");

            }

            if(kod === "pant_povrch") {
                var pant_spec = $(this).find("option:checked").attr("pant_spec");

                if( pant_spec === 0) {
                    configurator.switchClass(".pant_spec", "vsShow", "vsHide" );
                } else {
                    configurator.switchClass(".pant_spec", "vsHide", "vsShow" );
                }

                $("#pant_spec").select2("destroy").val(" ");

                $("#pant_spec option").each( function () {

                    $(this).removeAttr("disabled");
                    $(this).removeAttr("aria-disabled");

                    if( pant_spec !== $(this).attr("pant_spec") ) {
                        $(this).attr("disabled", "disabled");
                        $(this).attr("aria-disabled", "true");
                    }
                });

                formatSelectImage("pant_spec");

            }

            if(kod === "kod_pantu") {
                var kod_pantu = $(this).find("option:checked").attr("value");

                $("#pant_povrch").select2("destroy").val(" ");

                $("#pant_povrch option").each( function () {

                    $(this).removeAttr("disabled");
                    $(this).removeAttr("aria-disabled");

                    //console.log(kod_pantu + "    " + $(this).attr("kod_pantu"))
                    if( kod_pantu !== $(this).attr("kod_pantu") ) {
                        $(this).attr("disabled", "disabled");
                        $(this).attr("aria-disabled", "true");
                    }
                });

                formatSelectImage("pant_povrch");

            }

            if(kod === "kod_prov") {
                var kod_prov = $(this).find("option:checked").attr("prov_sklo");
                var grp_skla_filter = [];

                $("#kod_skla option").each( function () {

                    if( kod_prov !== $(this).attr("prov_sklo") ) {
                        grp_skla_filter.push( $(this).attr("data-filter") );
                    }
                });


                $("#grp_skla").select2("destroy").val(" ");

                $("#grp_skla option").each( function () {
                    $(this).removeAttr("disabled");
                    $(this).removeAttr("aria-disabled");

                    if( grp_skla_filter.indexOf( $(this).attr("kod_append") ) > 0 ) {
                        $(this).attr("disabled", "disabled");
                        $(this).attr("aria-disabled", "true");
                    }

                });

                formatSelectImage("grp_skla");

            }

            if(kod === "kod_skla") {
                var sklo_spec = $(this).find("option:checked").attr("sklo_spec");

                $("#sklo_spec").select2("destroy").val(" ");

                $("#sklo_spec option").each( function () {

                    $(this).removeAttr("disabled");
                    $(this).removeAttr("aria-disabled");

                    if( sklo_spec !== $(this).attr("sklo_spec") ) {
                        $(this).attr("disabled", "disabled");
                        $(this).attr("aria-disabled", "true");
                    }
                });

                formatSelectImage("sklo_spec");

            }

            configurator.validate();

        });
    },
    resetAll: function() {

        configurator.setConfig( "xcmd", "reset");
        configurator.getDataSession();

    },
    sendBasketCopy: function(){
        let data_send = "/&command=SET_PRODUCT_CONF&user_konf_id="+user_konf_id+"&e_mail="+email+"&cislo_nomenklatury="+id_nomen;
        var dataConf = "&sloupec=xcmd&hodnota=DO_KOSIKU_KOPIE";

        data_send += dataConf;

        var sendBasket = function(data) {

            Helper.addInfoText("Úspěšně přidáno do košíku");
            user_konf_id = data.user_konf_id;

            if( data.zmena ) {
                configurator.getDataSession();
            }

            setTimeout( function () {
                basketSetup.init();
            }, 500);

        }

        ajaxCall(data_send, sendBasket, true);

    },
    sendBasket: function(){
        let data_send = "/&command=SET_PRODUCT_CONF&user_konf_id="+user_konf_id+"&e_mail="+email+"&cislo_nomenklatury="+id_nomen;
        var dataConf = "&sloupec=xcmd&hodnota=DO_KOSIKU";

        data_send += dataConf;

        var sendBasket = function(data) {

            if(data.user_konf_id == 1) {
                Helper.addInfoText("Úspěšně přidáno do košíku");
                user_konf_id = data.user_konf_id;

                user_konf_id = 1;
            } else {
                Helper.addInfoText("Něco se pokazilo zkuste to prosím znovu. Děkujeme.");
            }
        }

        ajaxCall(data_send, sendBasket, true);

    },
    setConfig: function(name, value){

        let data_send = "/&command=SET_PRODUCT_CONF&user_konf_id="+user_konf_id+"&e_mail="+email+"&cislo_nomenklatury="+id_nomen;
        var dataConf = "&sloupec="+ name + "&hodnota=" + value;

        data_send += dataConf;

        var getSelect = function(data) {

            if(!configurator.configUrl() ) {
                user_konf_id = data.user_konf_id;
            }

            $(".idBasket").val(user_konf_id);

            var mnozstvi = parseInt($(".mnozstvi").val());
            if(mnozstvi < 1) {
                mnozstvi = 1;
            }

            $(".price_hodnota").html(parseInt(data["cena"]) * mnozstvi);

            if(data.zmena == 1) {
                configurator.getDataSession();
            }

        }

        if(value != undefined) {
            ajaxCall(data_send, getSelect, true);
        }

    },
    getDataSession: function() {

        let data_get = {n: 1, command: "GET_PRODUCT_CONF_ID", user_konf_id: user_konf_id};
        var setDataSelect = function(data) {

            if( data.smako_conf ) {
                var data = data.smako_conf.column;
                var mnozstvi = $(".mnozstvi").val();
                if(mnozstvi > 0) {
                    mnozstvi = 1;
                }

                $(".price_hodnota").html(parseInt(data["cena"]) * mnozstvi);

                for(var item in data) {

                    if(checkboxColumn.includes(item.replace("user_", ""))) {
                        $("#" + item + "_" + data[item]).prop("checked", true);
                    }

                    if( item.indexOf("user") > -1) {

                        if( $("input[name='" + item+"']").attr("type") != "radio" ) {
                            if( data[item] && data[item] != "NaN" ) {
                                if( $("input[name='" + item+"']").val() != parseInt(data[item])) {
                                    $("input[name='" + item+"']").val( parseInt(data[item])).trigger('change');
                                }
                            }
                        } else {
                            $("." + item + "_" + data[item]).click();
                        }

                        if( $("select[name='" + item + "']").val() !== Helper.replaceSpace(data[item]) ){
                            $("select[name='" + item + "']").val(Helper.replaceSpace(data[item])).trigger('change');
                        }

                    } else if( item.indexOf("mnozstvi") > -1 ) {
                        $("input[name='" + item+"']").val( parseInt(data[item]));
                    }

                }

                $(".user_poznamka").val( data["user_poznamka"] );

                if( data["sirka_max"] > 0 && data["vyska_max"] > 0) {

                    $(".user_vyska").attr("data-min", data["vyska_min"] );
                    $(".user_vyska").attr("data-max", data["vyska_max"] );
                    $(".user_sirka").attr("data-min", data["sirka_min"] );
                    $(".user_sirka").attr("data-max", data["sirka_max"] );

                    $(".user_vyska").attr("data-min-switch", data["sirka_min"] );
                    $(".user_vyska").attr("data-max-switch", data["sirka_max"] );
                    $(".user_sirka").attr("data-min-switch", data["vyska_min"] );
                    $(".user_sirka").attr("data-max-switch", data["vyska_max"] );

                    properties.setLimit(data["sirka_max"], data["sirka_min"], data["vyska_max"], data["vyska_min"]);

                }

            }
            configurator.initValid();
            configurator.clear();
        }
        ajaxCall(data_get, setDataSelect, false);

    },
    setConfigAll: function(){

        var $elements = $('#configurator_container select');
        let data_send = "/&command=SET_PRODUCT_CONF&user_konf_id="+user_konf_id+"&e_mail="+email+"&cislo_nomenklatury="+id_nomen;
        var dataConf="";
        $.each( $elements, function(i, field){

            dataConf += "&sloupec="+ field.name + "&hodnota=" + field.value;

        });

        data_send += dataConf;

        var getSelect = function(data) {

            if(!configurator.configUrl() ) {
                user_konf_id = data.user_konf_id;
            }

            $(".idBasket").val(user_konf_id);

            var data = data.smako_conf.column;
            var mnozstvi = $(".mnozstvi").val();
            if(mnozstvi < 1) {
                mnozstvi = 1;
            }

            $(".price_hodnota").html(parseInt(data.cena) * mnozstvi);

        }

        ajaxCall(data_send, getSelect, false);
    },
    resetAfterSendBasket: function(){
        configurator.getDataSession();
    },
    getCheckboxTemplate: function(data, label_text) {
        var div = document.createElement("div");
        var legend = document.createElement("legend");
        legend.textContent = window.labelName["user_"+label_text];
        legend.setAttribute("class", "label-user_"+label_text)

        if(col_md_3.includes(label_text)) {

            if(prov_sklo.includes(label_text)) {
                div.setAttribute("class","prov_sklo col-sm-3");
            } else {
                div.setAttribute("class","col-sm-3 " + label_text);
            }

        } else if(col_md_2.includes(label_text)) {

            if(prov_sklo.includes(label_text)) {
                div.setAttribute("class","prov_sklo col-sm-2 col-sm-1-5");
            } else {
                div.setAttribute("class","col-sm-2 " + label_text);
            }

        } else {

            if(prov_sklo.includes(label_text)) {
                div.setAttribute("class","prov_sklo col-sm-2");
            } else {
                div.setAttribute("class","col-sm-2 " + label_text);
            }
        }

        div.appendChild(legend);
        if(data.length > 0){

            for(var setInput in data_conf[label_text]) {
                var input = document.createElement("INPUT");
                var label = document.createElement("label");
                var img = document.createElement("img");
                img.setAttribute("loading", "lazy");

                if( data_conf[label_text][setInput].pic ) {
                    img.setAttribute("src", img_container + "/" + data_conf[label_text][setInput].pic );
                    img.setAttribute("class", "option-icon");
                    label.setAttribute("class", "withImg");
                    label.appendChild(img);
                } else {
                    label.textContent = data_conf[label_text][setInput].name;
                }

                label.setAttribute("for", data_conf[label_text][setInput].hodnota);
                label.setAttribute("class", label_text + "-" + data_conf[label_text][setInput].hodnota);
                input.setAttribute("id", "user_"+label_text + "_" + data_conf[label_text][setInput].hodnota);
                input.setAttribute("type","radio");
                input.setAttribute("name", "user_"+ label_text );
                input.setAttribute("value", data_conf[label_text][setInput].hodnota );

                div.appendChild(input);
                div.appendChild(label);
            }

        }

        return div;

    },
    getDataSelect: function(label_text, filter) {

        var data = new Array;
        for (var filter_data in data_conf[label_text] ){

            if( data_conf[label_text][filter_data].kod_grp === filter) {
                data.push( data_conf[label_text][filter_data] );
            }
        }
    },
    getSelectTemplate: function (data, label_text) {
        console.log(label_text, data)
        console.log(data)
        if(!data) {
            return;
        }
        data_conf[label_text] = data;

        var div = document.createElement("div");
        var select = document.createElement("SELECT");
        select.setAttribute("class", "select2-image");
        var label = document.createElement("Label");
        label.setAttribute("class", "label-user_" + label_text);

        var spanTooltip = document.createElement("span");
        spanTooltip.setAttribute("data-tooltip","");
        spanTooltip.setAttribute("aria-haspopup","true");
        spanTooltip.setAttribute("class","has-tip-top info-button");

        var i = document.createElement("i");
        i.setAttribute("class", "fa fa-info-circle");
        i.setAttribute("aria-hidden", "true");
        spanTooltip.appendChild(i);

        div.setAttribute("class","set_data");

        var className = label_text;
        if( data_conf[label_text].length === undefined && label_text == "patina" ) {
            className += " hideSet";
        }

        if(prov_sklo.includes(label_text)) {
            className += " prov_sklo";
        }

        if(col_md_3.includes(label_text)) {
            className += " col-sm-3";
        } else if(col_md_2.includes(label_text)) {
            className += " col-sm-2";
        } else {
            className += " col-sm-4";
        }

        if(window.helps["user_"+label_text]) {
            spanTooltip.setAttribute("title", window.helps["user_"+label_text]);
            div.appendChild(spanTooltip);
        }

        div.setAttribute("class", className );
        select.setAttribute("id", label_text );
        select.setAttribute("name", "user_"+label_text );
        label.textContent = window.labelName["user_"+label_text];

        div.appendChild(label);
        div.appendChild(select);

        // add empty option
        var option = document.createElement("option");
        option.innerHTML = " -- Vyberte možnost -- ";
        option.value = " ";
        option.setAttribute("select", "selected");
        select.appendChild(option);

        var option = document.createElement("option");
        select.appendChild(option);
        if(data === "disabled") {
            select.disabled;
            select.setAttribute("disabled","disabled");
        } else {

            if(data.length) {

                for (var x in data) {

                    var option = document.createElement("option");
                    option.value = Helper.replaceSpace(data[x].kod);
                    if(data[x].kod_grp) {
                        option.setAttribute("data-filter", Helper.replaceSpace(data[x].kod_grp));
                        option.setAttribute("class", data[x].kod_grp);
                    }
                    if(data[x].definice) {
                        option.setAttribute("data-definice", data[x].definice);
                    }
                    if(data[x].folie_spec) {
                        option.setAttribute("folie_spec", data[x].folie_spec);
                    }
                    if(data[x].smer_let) {
                        option.setAttribute("smer_let", data[x].smer_let);
                    }
                    if(data[x].zada_spec) {
                        option.setAttribute("zada_spec", data[x].zada_spec);
                    }
                    if(data[x].pant_spec) {
                        option.setAttribute("pant_spec", data[x].pant_spec);
                    }
                    if(data[x].kod_pantu) {
                        option.setAttribute("kod_pantu", data[x].kod_pantu);
                    }
                    if(data[x].sklo_spec) {
                        option.setAttribute("sklo_spec", data[x].sklo_spec);
                    }
                    if(data[x].prov_sklo) {
                        option.setAttribute("prov_sklo", data[x].prov_sklo);
                    }
                    if(data[x].pic) {
                        option.setAttribute("pic", data[x].pic);
                    }
                    if(data[x].html) {
                        option.setAttribute("html", data[x].html);
                    }
                    if(with_code.includes(label_text)) {
                        option.setAttribute("kod_append", data[x].kod);
                    }

                    option.innerHTML =  data[x].popis;
                    select.appendChild(option);
                }
            } else {

                option.value = data.kod;
                option.innerHTML = data.kod + " " + data.popis;

                if(data.kod_grp) {
                    option.setAttribute("data-filter", Helper.replaceSpace(data.kod_grp));
                    option.setAttribute("class", data.kod_grp);
                }
                if(data.definice) {
                    option.setAttribute("data-definice", data.definice);
                }
                if(data.folie_spec) {
                    option.setAttribute("folie_spec", data.folie_spec);
                }
                if(data.smer_let) {
                    option.setAttribute("smer_let", data.smer_let);
                }
                if(data.zada_spec) {
                    option.setAttribute("zada_spec", data.zada_spec);
                }
                if(data.pant_spec) {
                    option.setAttribute("pant_spec", data.pant_spec);
                }
                if(data.kod_pantu) {
                    option.setAttribute("kod_pantu", data.kod_pantu);
                }
                if(data.sklo_spec) {
                    option.setAttribute("sklo_spec", data.sklo_spec);
                }
                if(data.prov_sklo) {
                    option.setAttribute("prov_sklo", data.prov_sklo);
                }
                if(data.pic) {
                    option.setAttribute("pic", data.pic);
                }
                if(data.html) {
                    option.setAttribute("html", data.html);
                }

            }
        }

        return div;
    },
    getInputTemplate: function(name) {

        var div = document.createElement("div");
        var label = document.createElement("label");
        label.textContent = window.labelName["user_" + name];
        label.setAttribute("class", "label-user_" + name);

        var spanTooltip = document.createElement("span");
        spanTooltip.setAttribute("data-tooltip","");
        spanTooltip.setAttribute("aria-haspopup","true");
        spanTooltip.setAttribute("class","has-tip-top info-button");

        var i = document.createElement("i");
        i.setAttribute("class", "fa fa-info-circle");
        i.setAttribute("aria-hidden", "true");
        spanTooltip.appendChild(i);

        if(window.helps["user_"+name]) {
            spanTooltip.setAttribute("title",window.helps["user_"+name]);
            div.appendChild(spanTooltip);
        }

        div.setAttribute("class","col-sm-3");
        var input = document.createElement("input");
        input.setAttribute("type", "text");
        if(name != "poznamka") {
            input.setAttribute("name", "user_" + name);
        }
        input.setAttribute("id", name);
        input.setAttribute("class", "preview");
        div.appendChild(label);
        div.appendChild(input);

        return div;
    },
    getOrnamentTemplate: function(number){
        var div = document.createElement("div");
        div.setAttribute("class", "ornam_" + number);
        div.setAttribute("class", "ornament" );
        div.setAttribute("data-number", number);

        // Ornament
        var div_col = configurator.getSelectTemplate(ornament_modul.ornament, "m" + number);
        div.appendChild(div_col);

        // otočená
        var div_col = configurator.getSelectTemplate(data_conf["otoceni"], "m" + number + "_o");
        div.appendChild(div_col);

        // M1
        var div_col = configurator.getInputTemplate("m"+ number + "_x");
        div.appendChild(div_col);

        // M2
        var div_col = configurator.getInputTemplate("m"+ number + "_y");
        div.appendChild(div_col);

        $("#modulForm").append(div);

        $("#m" + number).change( function () {
            if($(this).val()) {
                var number = parseInt($(this).parents("div.ornament").attr("data-number")) + 1;
                if( !$(".ornament[data-number='" + number + "']").length ) {
                    if(number < 10) {
                        configurator.getOrnamentTemplate(number);
                        modulImage.init();
                    }
                }
            }
        });

        setTimeout( function () {
            formatSelectImage("m" + number);
            formatSelectImage("m" + number + "_o");
        }, 400);

    },
    modul: function() {

        $(".mc").each(function () {
            $(this).addClass($(this).attr("data-modul"));
            $(this).removeClass($(this).attr("data-modul-remove"));
        });

        $(".express-container").html($(".express").html()).show();
        $(".express").remove();

        $(".express-poznamka").html($(".poznamka").html()).show();
        $(".poznamka").remove();

        $(".modul-fix").addClass("setModule");

        configurator.getOrnamentTemplate(1);

        $("#modulForm").show();

        modulImage.init();

    },
    getConf: async function () {
        let template = "";
        let data_send = "?n=1&command=GET_PRODUCT_CONF&cislo_nomenklatury=" + id_nomen;

        let getSelect = function(data) {

            let objecty = data["smako_conf_grp_pantu"];
            console.log("ty veci" + objecty)
            if (objecty && objecty.length > 0) {
                const unikatniObjecty = objecty.map(obj => obj.grp_pantu);
                console.log(unikatniObjecty)
                data["smako_conf_grp_pantu"] = []

                data["smako_conf_grp_pantu"].grp_pantu = unikatniObjecty[0]
            }
            console.log(data)

            ornament_modul = data["smako_conf_ornament"];

            if(typ_atributu == "NBDIL") {
                $("#konfigurator").addClass("NBDIL");
                column = column_nbdil;
            } else if(typ_atributu == "MODUL") {
                $("#konfigurator").addClass("MODUL");
                column = column_modul;
                configurator.modul();
            } else if(typ_atributu == "HP") {
                $("#konfigurator").addClass("HP");
                column = column_hp;
                configurator.hideElement(column_hp_delete);
                setTimeout( function () {
                    $(".kod_pantu").find("label").html("Montážní sada");
                }, 300);
            } else if(typ_atributu == "LISTA") {
                $("#konfigurator").addClass("LISTA");
                column = column_lista;
                configurator.hideElement(column_lista_delete);
            } else if(typ_atributu == "SKVD") {
                $("#konfigurator").addClass("SKVD");
                column = column_sklo;
                //configurator.hideElement(column_lista_delete);
            } else if(typ_atributu == "LIPRO") {
                $("#konfigurator").addClass("LIPRO");
                column = column_lipro;
                configurator.hideElement(column_lipro_delete);
            } else if(typ_atributu == "DRVD") {
                $("#konfigurator").addClass("DRVD");
                column = column_drvd;

            }  else if(typ_atributu == "UAL") {
                $("#konfigurator").addClass("UAL");
                column = column_ual;
                configurator.hideElement(column_ual_delete);

            } else if(typ_atributu == "UCHMM") {
                $("#konfigurator").addClass("UCHMM");
                column = column_uchmm;
                configurator.hideElement(column_uchmm_delete);
                setTimeout( function () {
                    $(".height").find("label[for='input-2']").html("Délka");
                }, 300);
            }

            $.each(column, function (i) {

                column_set = data["smako_conf_" + column[i]];


                if(checkboxColumn.includes(column[i])){
                    template = configurator.getCheckboxTemplate( column[i], column[i]);
                } else if( column[i]=== "" ) {

                    var div = document.createElement("div");
                    div.setAttribute("class", "col-sm-4 empty");
                    template = div;

                } else if(column[i] == "hrana_p" || column[i] == "hrana_d" || column[i] == "hrana_h" || column[i] == "hrana_l") {

                    var column_set_hrana = data["smako_conf_hrana"];

                    if(column_set_hrana) {
                        template = configurator.getSelectTemplate(column_set_hrana["hrana"], column[i]);
                    }

                } else {

                    if(column_set === null) {
                        template = configurator.getSelectTemplate("disabled", column[i]);
                    } else if(column_set) {
                        template = configurator.getSelectTemplate(column_set[column[i]], column[i]);
                    } else {
                        if(data_conf[column[i]]) {
                            template = configurator.getSelectTemplate(data_conf[column[i]], column[i]);
                        }
                    }
                }

                $("#configurator_container").append(template);


                if(!checkboxColumn.includes(column[i])) {
                    formatSelectImage(column[i]);
                }

            });

            if(  typ_atributu == "SKVD" || typ_atributu == "DRVD" ) {
                $(".prov_sklo").show();
            }

            configurator.initSelectChange();
            configurator.initInputChange();
            configurator.getDataSession();
            color_panel.init();
            next_variant.init();
        };

        let data = await AxiosApi(data_send);

        getSelect(data.root);
    },
    hideElement: function(data) {
        for(var i=0; i< data.length; i++) {
            $("."+data[i]).remove();
        }
    },
    initValid: function () {
        for( var item in window.validator ) {
            $("[name='"+ window.validator[item] + "']").addClass("required");
        }
    },
    validate: function () {

        var validate = 0;

        $(".required").each( function(){

            if( $(this).val()==0 || $(this).val() == undefined ) {
                $(this).addClass("error");
                $(this).parent("div").addClass("error");
                $(this).parent("div").find(".error_text").remove();
                $(this).parent("div").append(error);
                ++validate;
            } else {
                $(this).removeClass("error");
                $(this).parent("div").removeClass("error");
                $(this).parent("div").find(".error_text").remove();
            }


            if( $(this).hasClass("user_vyska") || $(this).hasClass("user_sirka") ) {

                let switch_size = false;
                if( $(this).hasClass("switch_size") ) {
                    switch_size = true;
                }
                var error2 = '<div class="error error_text">Zadaný rozměr není v možném rozmezí.</div>';

                let min = parseInt($(this).attr("data-min")) || 0;
                let max = parseInt($(this).attr("data-max")) || 10000;
                let min_switch = parseInt($(this).attr("data-min-switch")) || 0;
                let max_switch = parseInt($(this).attr("data-max-switch")) || 10000;

                if( min <= parseInt($(this).val()) && parseInt($(this).val()) <= max ) {
                    $(this).removeClass("error");
                    $(this).parent("div").removeClass("error");
                    $(this).parent("div").find(".error_text").remove();
                } else if( switch_size && min_switch <= parseInt($(this).val()) && parseInt($(this).val()) <= max_switch ) {

                    if( $(this).hasClass("user_vyska") && min <= parseInt($(".user_sirka").val()) && parseInt($(".user_sirka").val()) <= max ) {

                        $(this).removeClass("error");
                        $(this).parent("div").removeClass("error");
                        $(this).parent("div").find(".error_text").remove();

                    } else if( $(this).hasClass("user_sirka") && min <= parseInt($(".user_vyska").val()) && parseInt($(".user_vyska").val()) <= max ) {

                        $(this).removeClass("error");
                        $(this).parent("div").removeClass("error");
                        $(this).parent("div").find(".error_text").remove();

                    } else {
                        $(this).addClass("error");
                        $(this).parent("div").addClass("error");
                        $(this).parent("div").find(".error_text").remove();
                        $(this).parent("div").append(error2);
                        ++validate;
                    }

                } else {
                    $(this).addClass("error");
                    $(this).parent("div").addClass("error");
                    $(this).parent("div").find(".error_text").remove();
                    $(this).parent("div").append(error2);
                    ++validate;
                }
            }

        });

        if(validate == 0) {
            $("._addToBasket").addClass("validate");
        } else {
            $("._addToBasket").removeClass("validate");
        }

    },
    configUrl: function () {
        if(Helper.getUrlVars()["conf_nb"]) {
            user_konf_id = Helper.getUrlVars()["conf_nb"].match(/\d+/)[0];
            $("._addToBasket").text("ULOŽIT ZMĚNY");
            $("._addToBasket").attr("after", "redirect_basket");
            return user_konf_id;
        } else {
            return false;
        }
    },
    loaderInit: function () {
        //$(".conf_container").css("visibility", "hidden");
        $("#konfigurator").append(loader);
    },
    clear: function () {
        $(".conf_container").css("visibility", "visible");
        //$("#konfigurator").find(".lds-default").remove();
    }
};

function parseDateTime(datetime) {
    var monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
    ];
    if(datetime.split(' ').length == 3){
        var date = datetime.split(' ')[0];
        var time = datetime.split(' ')[1].replace('.00','');
        var timearray = time.split(':');
        var hours = parseInt(time.split(':')[0]);
        var format = datetime.split(' ')[2];
        var bits = date.split(/\D/);
        date = new Date(bits[0], --bits[1], bits[2]); /* if you change format of datetime which is passed to this function, you need to change bits e.x ( bits[0], bits[1], bits[2 ]) position as per date, months and year it represent bits array.*/
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        if ((format === 'PM' || format === 'pm') && hours !== 12) {
            hours += 12;
            try{  time = hours+':'+timearray[1]+':'+timearray[2] }catch(e){ time = hours+':'+timearray[1] }
        }
        var formateddatetime = new Date(monthNames[monthIndex] + ' ' + day + '  ' + year + ' ' + time);
        return formateddatetime;
    }else if(datetime.split(' ').length == 2){
        var date = datetime.split(' ')[0];
        var time = datetime.split(' ')[1];
        var bits = date.split(/\D/);
        var datetimevalue = new Date(bits[0], --bits[1], bits[2]); /* if you change format of datetime which is passed to this function, you need to change bits e.x ( bits[0], bits[1], bits[2 ]) position as per date, months and year it represent bits array.*/
        var day = datetimevalue.getDate();
        var monthIndex = datetimevalue.getMonth();
        var year = datetimevalue.getFullYear();
        var formateddatetime = new Date(monthNames[monthIndex] + ' ' + day + '  ' + year + ' ' + time);
        return formateddatetime;
    }else if(datetime != ''){
        var bits = datetime.split(/\D/);
        var date = new Date(bits[0], --bits[1], bits[2]); /* if you change format of datetime which is passed to this function, you need to change bits e.x ( bits[0], bits[1], bits[2 ]) position as per date, months and year it represent bits array.*/
        return date;
    }
    return datetime;
}

const detail = {
     init: async function () {

        let data_send = "?n=1&command=GET_PRODUCT_DETAIL&cislo_nomenklatury="+ id_nomen;
        function getImage(data) {

            if( !configurator.configUrl() ) {
                user_konf_id = data.smako_conf.config.user_konf_id;
            }

            url_nahled = data.smako_url_nahed.url.url_nahled;

            var element = data.nomenklatura_detail;

            typ_atributu = data.nomenklatura_detail.typ_atributu;
            configurator.init();

            if(element.properties_items) {
                properties.init(element.properties_items.properties_item);
            } else {
                $("#params").hide();
            }

            if (element.file_items != null) {
                file_data = element.file_items.file_item;
            }

            if(data.smako_tech_info) {
                smako_tech_info = data.smako_tech_info.smako_tech_info;

                if(smako_tech_info.length) {
                    for (var item in smako_tech_info) {
                        template_tech += '<div class="parametr"><img loading="lazy" src="/App_Firma/data/'+ smako_tech_info[item].pic +'" data-tooltip aria-haspopup="true" class="has-tip-top" data-disable-hover="false" tabindex="1" title="' + smako_tech_info[item].popis + '" data-position="top" data-alignment="right" ></div>';
                    }
                } else {
                    template_tech += '<div class="parametr"><img loading="lazy" src="/App_Firma/data/'+ smako_tech_info.pic +'" data-tooltip aria-haspopup="true" class="has-tip-top" data-disable-hover="false" tabindex="1" title="' + smako_tech_info.popis + '" data-position="top" data-alignment="right" ></div>';
                }

                $(".tech_info").html(template_tech);
            } else {
                $("#parametry").hide();
            }

            detail.navigateNomen(data.smako_nom_nav.navigace.next_nom, ".next_nomen");
            detail.navigateNomen(data.smako_nom_nav.navigace.prev_nom, ".prev_nomen");

            if( file_data.length > 1) {
                for(var item in file_data) {
                    detail.getpicture(file_data[item]);
                }
            } else {
                detail.getpicture(file_data);
            }

            $("#galleryDetail").html("<div class='slick-product'>" + templateMain + "</div>");
            $("#galleryDetail").append("<div class='slick-nav'>" + template + "</div>");

            $('.slick-product').slick({
                slidesToScroll: 1,
                autoplay: true,
                arrows: false,
                lazyLoad: 'ondemand', // ondemand progressive anticipated
                infinite: true,
                asNavFor: '.slick-nav'
            });

            $('.slick-nav').slick({
                slidesToShow: 7,
                slidesToScroll: 1,
                asNavFor: '.slick-product',
                arrows: false,
                dots: false,
                draggable: false,
                centerMode: true,
                focusOnSelect: true
            });

            setTimeout( function () {
                detail.clear();
            }, 2000);

        }

        let data = await AxiosApi(data_send);
        getImage(data.root);
    },
    getpicture: function( file_data ){

        if(file_data) {
            var ts = ((parseDateTime(file_data.ts).getTime() * 10000) + 621355968000000000) - (parseDateTime(file_data.ts).getTimezoneOffset() * 600000000);

            ts = ts.toString();
            var root = "/App_Firma/Data/Products/";

            var file_image, file_imageSmall = "";
            let nameFile = file_data.file_name.toLowerCase();

            if ( nameFile ) {

                if( file_data.description == "#ZSHOP_PICTURE_DETAIL_MAIN;" || file_data.description == "#ZSHOP_PICTURE_DETAIL;") {

                    file_image = root + file_data.pk + "_" + file_data.poradi + "_" + file_data.file_name.replace(".", "_") + "_" + ts + Suffix.init(nameFile);
                    file_imageSmall = root + "preview/p_" + file_data.pk + "_" + file_data.poradi + "_" + file_data.file_name.replace(".", "_") + "_" + ts + Suffix.init(nameFile);

                    //document.getElementById("main_gallery").setAttribute("src", file_image );
                    templateMain += '<img src="' + file_image + '"  />';
                    template += '<img src="/App_Firma/img/default.jpg" data-src="' + file_imageSmall + '" loading="lazy" class="js_preload" />';

                } else if(file_data.description == "#ZSHOP_PICTURE_TVAR;"){

                    var file_tvar = root + file_data.pk + "_" + file_data.poradi + "_" + file_data.file_name.replace(".", "_") + "_" + ts + Suffix.init(nameFile);
                    var template_tvar = '<img src="' + file_tvar + '"  loading="lazy" />';
                    $(".nomen_desk").append( template_tvar);

                } else if(file_data.description == "#ZSHOP_PICTURE_REZ;") {

                    var file_rez = root + file_data.pk + "_" + file_data.poradi + "_" + file_data.file_name.replace(".", "_") + "_" + ts + Suffix.init(nameFile);
                    var template_rez = '<img src="' + file_rez + '" loading="lazy" />';
                    $(".rez_dvirky").append(template_rez);
                    $("#cut_door").show();


                } else if(file_data.description == "#ZSHOP_PICTURE_UCH;") {

                    var file_uch = root + file_data.pk + "_" + file_data.poradi + "_" + file_data.file_name.replace(".", "_") + "_" + ts + Suffix.init(nameFile);
                    var template_uch = '<img src="' + file_uch + '" loading="lazy" />';
                    $(".pant_variant").append(template_uch);
                    $("#uchytky").show();

                } else if( file_data.att_class == "ZSHOP_FILE" ) {
                    var file_href = container_documents + "/" + file_data.pk + "_" + file_data.poradi + "_" + file_data.file_name.replace(".", "_") + "_" + ts + Suffix.init(nameFile);
                    $("[attr-download='" + file_data.description + "']").attr("href", file_href).css("display","block");
                }

               // var file_href = container_documents + "/" + file_data.pk + "_" + file_data.poradi + "_" + file_data.file_name.replace(".", "_") + "_" + ts + Suffix.init(nameFile);

            }
        }

    },
    navigateNomen: function(nomen, where){

        var nextNomen = nomen.replace("/", "+++");

        $(where).attr("href", "/Product/cs-CZ/" + nextNomen + "/_");
        if(where == ".next_nomen") {
            $(where).prepend(nomen + "&nbsp;");
        } else {
            $(where).append("&nbsp;" + nomen);
        }

    },
    loaderInit: function () {
        $("#galerie").before(loader);
        $(".tech_info").html(loader);
        $('a[href="#galerie"]').append(loader);
    },
    clear: function () {

        $("#galerie").prev().remove();
        $('a[href="#galerie"]').find(".lds-default").remove();
    }
}

var color_panel = {
    init: function () {

        var data = data_conf["grp_folie"];
        var img = data_conf["kod_folie"];

        var template = "", tabs_content = "", img_content = "";
        var template2 = "", tabs_content2 = "", img_content2 = "";
        var first = true;
        var ariahiden = false;
        var class_active = "";

        if(data)
        {
            $("#barvy .tabs-content").append(loader);
            if(data.length) {
                for( var item in  data) {

                    class_active = "";

                    if(first) {
                        class_active = "is-active";
                        ariahiden = false;
                    }
                    template += "<li class='has-color-tip tabs-title " + class_active + "' role='presentation' title='" + data[item].popis + "'><a data-tabs-target='#" + data[item].kod + "'>" + data[item].kod + "</a></li>";
                    tabs_content += "<div aria-hidden='" + ariahiden + "' class='tabs-panel " + class_active + "' id='" + data[item].kod + "'><p></p><section class='slick-decor'></section></div>";

                    template2 += "<li class='collection-card " + class_active + "' role='presentation' title='" + data[item].popis + "'><a data-tabs-target='#" + data[item].kod + "'>" + data[item].kod + "</a></li>";
                    tabs_content2 += "<div aria-hidden='" + ariahiden + "' class='tabs-panel " + class_active + "' id='" + data[item].kod + "'><p></p><section class='slick-decor'></section></div>";

                    first = false;
                    ariahiden = true;
                }
            } else {
                class_active = "";
                if(first) {
                    class_active = "is-active";
                    ariahiden = false;
                }
                template = "<li class='has-color-tip tabs-title " + class_active + "' role='presentation' title='" + data.popis + "'><a data-tabs-target='#" + data.kod + "'>" + data.kod + "</a></li>";
                tabs_content = "<div aria-hidden='" + ariahiden + "' class='tabs-panel " + class_active + "' id='" + data.kod + "'><p></p><section class='slick-decor'></section></div>";

            }

            setTimeout( function () {


                $("#barvy").find("#color_tabs").html(template);
                $("#barvy").find(".tabs-content").html(tabs_content);
                $("#barvy").find(".loader").remove();

                $("#sample").html(template);
                
                if( img.length ) {
                    for (var item in img) {
                        img_content = '<figure class="gallery-item"><img loading="lazy" src="'+ img_container_icon + '/' + img[item].pic + '"><figcaption class="img-title"><h5>' + img[item].kod + '<br>' + img[item].popis + '</h5></figcaption></figure>';
                        $("#" + img[item].kod_grp).find("section").append(img_content);
                    }
                } else {
                    img_content = '<figure class="gallery-item"><img loading="lazy" src="'+ img_container_icon + '/' + img.pic + '"><figcaption class="img-title"><h5>' + img.kod + '<br>' + img.popis + '</h5></figcaption></figure>';
                    $("#" + img.kod_grp).find("section").append(img_content);
                }


                $("#color_tabs").addClass("tabs").attr("data-tab","");

                $(".has-color-tip").qtip({ // Grab all elements with a title attribute
                    content: {
                        text: $(this).attr("title") // Won't work, because "this" is the window element!
                    },
                    show: {
                        event: 'mouseover',
                        solo: true
                    },
                    hide: {
                        event: 'click unfocus'
                    },
                    overwrite: false, // Make sure the tooltip won't be overridden once created
                    position: {
                        my: "bottom center",
                        at: "top center",
                    },
                    style: {
                        classes: 'qtip-bootstrap',
                        tip: {
                            width: 16,
                            height: 8
                        }
                    }
                });

                // Slick
                $('.slick-decor').slick({
                    dots: true,
                    vertical: false,
                    centerMode: false,
                    accessibility: true,
                    rows: 2,
                    slidesPerRow: 6,
                    lazyLoad: 'ondemand', // ondemand progressive anticipated
                    infinite: false,
                    nextArrow: '<i class="fa fa-chevron-right"></i>',
                    prevArrow: '<i class="fa fa-chevron-left"></i>',
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            rows: 3,
                            slidesPerRow: 4,
                        }
                    }]
                });

                // color panel helper
                $(".tabs-title").click( function () {
                    var id = $(this).find("a").attr("data-tabs-target");
                    $(".tabs-title").removeClass("is-active");
                    $(".tabs-panel").removeClass("is-active");
                    $(this).addClass("is-active");
                    $(id).addClass("is-active");
                });


            }, 1000);
        }

    },
    fillTemplate: function () {

    }
}

var properties = {
    init: function (data) {

        var table = document.getElementById("table_prop");
        var max_width, max_height, min_width, min_height = 0;

        for ( var item in data) {
            var row = table.insertRow(0);
            var cell1 = row.insertCell(0);
            var cell2 = row.insertCell(1);
            cell1.innerHTML = data[item].vlastnost_nazev;

            if ( data[item].properties_values_items ) {

                cell2.innerHTML = data[item].properties_values_items.properties_values_item.nazev_pro_web;

                if(data[item].vlastnost == "SIRKA_MAX" ) {
                    max_width = data[item].properties_values_items.properties_values_item.nazev_pro_web;
                }
                if(data[item].vlastnost == "SIRKA_MIN" ) {
                    min_width = data[item].properties_values_items.properties_values_item.nazev_pro_web;
                }
                if(data[item].vlastnost == "VYSKA_MAX" ) {
                    max_height = data[item].properties_values_items.properties_values_item.nazev_pro_web;
                }
                if(data[item].vlastnost == "VYSKA_MIN" ) {
                    min_height = data[item].properties_values_items.properties_values_item.nazev_pro_web;
                }
            }

        }


        if(data[item].vlastnost) {
            properties.setLimit(max_width, min_width, max_height, min_height);
            $("#params").show();
        } else {
            $("#params").hide();
        }

    },

    setLimit: function (max_width, min_width, max_height, min_height) {

        var width_text = "Minimální šířka " + min_width + ", maximální šířka " + max_width;
        $(".width_limit").html(width_text);

        var height_text = "Minimální výška " + min_height + ", maximální výška " + max_height;
        $(".height_limit").html(height_text);

    }
}

var next_variant = {
    init: function () {

        var data = data_conf["kod_prov"];
        var img = "";

        if(data) {
            if( data.length ) {
                for (var item in data) {
                    img += '<div class="cell product"><img class="js_preload" src="/App_Firma/img/default.jpg" data-src="'+ img_container_icon + '/' + data[item].pic + '"><div class="title"><strong>' + data[item].kod + '  </strong><br />   ' + data[item].popis + '</div> </div>';
                }
            } else {
                img = '<div class="cell product"><img class="js_preload" src="/App_Firma/img/default.jpg" data-src="'+ img_container_icon + '/' + data.pic + '"><div class="title"><strong>' + data.kod + '  </strong><br />  '  + data.popis + '</div> </div>';
            }
        }

        $(".next_variant").append(img);

        next_variant.clear();
    },
    loaderInit: function () {
        $(".next_variant").append(loader);
    },
    clear: function () {
        $(".next_variant").find(".lds-default").remove();
        let preloadImg = PreloadImages;
        preloadImg.preload();
    }
}

var modulImage = {
    init: function () {
        $(".preview, #m1, #m1_o, #m2, #m2_o, #m3, #m3_o, #m4, m4_o, #m4, m4_o, #m5, m5_o, #m6, m6_o, #m7, m7_o, #m8, m8_o, #m9, #m9_o").change( function () {
            modulImage.getPreview();
        });
    },
    getPreview: function () {
        let height = $(".user_vyska").val();
        let width = $(".user_sirka").val();
        let m = "";
        let url = url_nahled + "/Wysokość/" + height + "/Szerokość/" + width;

        for( var i=1; i<10; i++) {
            m = $("#m"+i).val();
            if(m) {
                m = m.replace("/", "_");
            }
            if( m == "ZV") {
                m = "struktura";
            }
            if(m) {
                url += "/Ornament " + i + "/" + m + "/Ornament " + i + " obrót/" + $("#m" + i + "_o").val();
                url += "/Ornament " + i + " M1/" + $("#m"+i + "_x").val() + "/Ornament " + i + " M2/" + $("#m" + i + "_y").val();
            }
        }

        url += "/linie/1";

        var img = document.createElement("img");
        img.setAttribute("loading", "lazy");

        if(height > 0 && width > 0) {
            img.setAttribute("src", url );
            $("#modulFormImage").html(img);
        }

    }
}

var pant_variant = {
    init: function () {
        var data = data_conf["kod_pantu"];

        if(data.length) {
            for (var item in data) {
                var img = '<div class="cell product"><img loading="lazy" src="'+ img_container_icon + '/' + data[item].pic + '"><span class="title">' + data[item].kod + ' ' + data[item].popis + '</span> </div>';
                $(".pant_variant").append(img);
            }
        } else {
            var img = '<div class="cell product"><img loading="lazy" src="'+ img_container_icon + '/' + data.pic + '"><span class="title">' + data.kod + ' ' + data.popis + '</span> </div>';
            $(".pant_variant").append(img);
        }
    }
}

jQuery(document).ready( function ($) {

    // When edit in basket -- url haf conf_nb
    configurator.configUrl();

    $(".idBasket").val(user_konf_id);
    $(window).load(function() {

        detail.init();

        $(".resetConf").click(function () {
            configurator.resetAll();
        });

        $("._addBasketReset").click( function (e) {
            e.preventDefault();
            configurator.resetAll();
        });

        basketSetup.init();

        $("#konfigurator textarea").change(function(){

            configurator.setConfig( $(this).attr("name") , $(this).val());

        });

        // express
        $(".switch-paddle").click( function () {
            var checkBoxes = $("#express");
            if(checkBoxes.val() == 1) {
                checkBoxes.val(0);
            } else {
                checkBoxes.val(1);
            }

        });

        $("._addToBasket").click( function () {

            configurator.initValid();
            configurator.validate();
            if($(this).hasClass("validate")) {
                //configurator.sendBasket();
                configurator.sendBasketCopy();

                setTimeout( function () {
                    configurator.resetAfterSendBasket();
                }, 500)
            }
            $(".basket_count").text( parseInt($(".basket_count").text()) + 1 );

            if( $(this).attr("after") == "redirect_basket" ) {
                location.href = "/kosik";
            }

        });

        $(".select2-selection__rendered").hover( function() {

            if( $(this).find("img").length > 0 ) {
                var img =  $(this).find("img").clone();
                var span_hover = "<span class='span_hover'></span>";
                $(this).append(span_hover);
                $(".span_hover").append(img);
            }

        });

        $(".select2-selection__rendered").mouseleave( function() {

            $(".span_hover").remove();

        });

        $(".has-tip").qtip({ // Grab all elements with a title attribute
            content: {
                text: $(this).attr("title") // Won't work, because "this" is the window element!
            },
            show: {
                event: 'mouseover',
                solo: true
            },
            hide: {
                event: 'click unfocus'
            },
            overwrite: false, // Make sure the tooltip won't be overridden once created
            position: {
                my: 'top center',
                at: 'bottom center'
            },
            style: {
                classes: 'qtip-bootstrap',
                tip: {
                    width: 16,
                    height: 8
                }
            }
        });

    });


});

let preloadImg = PreloadImages;
let fallImages = FallbackImages;

window.addEventListener( "DOMContentLoaded", function(){

    NameCols.getLabel();

    setTimeout( function(){
        preloadImg.preload();
    }, 10000)

    setTimeout( function(){
        fallImages.fallbackImages();
    }, 3000)
});
